// This file was generated by the Zuplo CLI migrate-dev-portal command.
// It is used to configure the Zuplo dev portal.
// You can edit this file to customize the dev portal.
// For more information, see https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "Reelyze Developer API",
    logo: {
      src: {
        light:
          "https://cdn.reelyze.com/publicassets/reelyze_logo_with_name_light.png",
        dark: "https://cdn.reelyze.com/publicassets/reelyze_logo_with_name_light.png",
      },
      alt: "Reelyze Developer API",
      href: "/",
      width: 200,
    },
  },
  metadata: {
    favicon: "https://portal.reelyze.com/favicon.ico",
    title: "Reelyze Developer API",
  },
  basePath: "/",
  navigation: [
    {
      type: "doc",
      file: "index",
      label: "Welcome",
      path: "/",
    },
    {
      type: "category",
      label: "Getting Started",
      items: [
        {
          type: "doc",
          file: "overview",
          label: "Overview",
        },
        {
          type: "doc",
          file: "getting-started",
          label: "Getting Started",
        },
        {
          type: "doc",
          file: "api-keys",
          label: "API Keys",
        },
        {
          type: "doc",
          file: "standard-responses",
          label: "Standard Responses",
        },
        {
          type: "doc",
          file: "rate-limits",
          label: "Rate Limits",
        },
      ],
    },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "/api",
    },
  ],
  authentication: {
    type: "auth0",
    clientId: "t9yExtxLwxd1CDRLxInjugf5utrUXGfP",
    domain: "login.talkout.com",
    audience: "https://developer-api.reelyze.com/",
  },
  redirects: [{ from: "/docs", to: "/" }],
};
export default config;
